import React from 'react';
import SiteContentContext from './SiteContentContext';
import { SiteContentHtmlParser } from './SiteContentHtmlParser';
import { useQuery } from 'react-apollo';
import siteContentQuery from './siteContentQuery.gql';
import { config } from '../../shop.config.custom';
import { convertPropsToObject } from '../ContentRender/ContentRender';
import { useContext } from 'react';
import ChannelContext from '@jetshop/core/components/ChannelContext';

export const convertPropsToSiteContentObject = (item) => {
  const props = item.properties.reduce((merged, current) => {
    const propValue = current.value && current.value.value;
    merged[current.name] =
      current.type === 'html' ? (
        <SiteContentHtmlParser content={propValue} />
      ) : current.type === 'dropdown' && current.name.search('show') !== -1 ? (
        propValue === 'yes' ? (
          true
        ) : (
          false
        )
      ) : (
        propValue
      );
    return merged;
  }, {});
  return props;
};

const SiteContent = ({ children }) => {
  const { selectedChannel } = useContext(ChannelContext);

  const result = useQuery(siteContentQuery, {
    variables: {
      id:
        selectedChannel.name === 'B2B'
          ? config.settings.siteContentIdB2B
          : config.settings.siteContentId,
    },
  });

  const startPage = result?.data?.startPage;
  const items = startPage?.data?.items;

  const siteContentObject =
    items && items.filter((item) => item.type === 'site-content')[0];

  const otherObjects =
    items && items.filter((item) => item.type !== 'site-content');

  const menuImagesObject =
    items &&
    items.filter((item) => item.type === 'site-content-menu-images')[0];

  const blogObject =
    items && items.filter((item) => item.type === 'category-blogs')[0];

  const props =
    siteContentObject && convertPropsToSiteContentObject(siteContentObject);

  const blogProps = blogObject?.children.map((item) =>
    convertPropsToObject(item)
  );

  const menuImages = {
    ...convertPropsToObject(menuImagesObject),
    items: menuImagesObject?.children.map((item) => convertPropsToObject(item)),
  };

  return (
    <SiteContentContext.Provider
      value={{
        ...props,
        rest: otherObjects,
        blogs: blogProps,
        menuImages: menuImages,
      }}
    >
      {children}
    </SiteContentContext.Provider>
  );
};

export default SiteContent;
